import { useEffect, useMemo, useState } from 'react';
import './CharacterShapingProgram.css';

import treeImage from './assets/Tree_for_Character_Shaping_Program.png';

import heroSlide1 from './assets/news/new2.jpg';

import heroSlide2 from './assets/news/news5.jpg';

import heroSlide3 from './assets/news/news8.jpg';

import clubImage1 from './assets/news/news1.jpg';

import clubImage2 from './assets/news/news3.jpg';

import clubImage3 from './assets/news/news4.jpg';

import clubImage4 from './assets/news/news6.jpg';

import clubImage5 from './assets/news/news7.jpg';

import eventImage1 from './assets/news/news1.jpg';

import eventImage2 from './assets/news/news4.jpg';

import eventImage3 from './assets/news/news5.jpg';

import eventImage4 from './assets/news/news7.jpg';

import eventImage5 from './assets/news/new2.jpg';



function StudentLifePage({ page, onNavigate }) {

  const heroSlides = page?.hero_slides || [heroSlide1, heroSlide2, heroSlide3];

  const [activeHero, setActiveHero] = useState(0);

  const [activeWellbeingSlide, setActiveWellbeingSlide] = useState(0);

  const [activeWellbeingCard, setActiveWellbeingCard] = useState(0);

  const [activeTreeZone, setActiveTreeZone] = useState('easternCulture');
  const [showTreeModal, setShowTreeModal] = useState(false);
  const [flippedLeapsCard, setFlippedLeapsCard] = useState(null);



  useEffect(() => {

    const intervalId = setInterval(() => {

      setActiveHero((current) => (current + 1) % heroSlides.length);

    }, 6000);



    return () => clearInterval(intervalId);

  }, [heroSlides.length]);



  useEffect(() => {

    const intervalId = setInterval(() => {

      setActiveWellbeingSlide((current) => (current + 1) % 3);

    }, 5000);



    return () => clearInterval(intervalId);

  }, []);



  const clubs = useMemo(
    () =>
      page?.clubs || [
        {
          title: 'Sports & Athletics Club',
          subtitle: 'Teamwork, discipline, and healthy competition',
          description:
            'Students build confidence through structured training sessions, friendly matches, and seasonal tournaments. Activities include futsal, basketball, badminton, and athletics conditioning tailored to each level.',
          highlights: ['Weekly training sessions', 'Interschool friendly matches', 'Fitness and agility drills'],
          images: [clubImage1, clubImage4, clubImage5],
        },
        {
          title: 'Arts, Music, and Performance',
          subtitle: 'Creativity on stage and beyond',
          description:
            'From choir to contemporary dance, students explore creative expression with guidance from professional coaches. Showcases, exhibitions, and recitals help students share their talents with the community.',
          highlights: ['Choir and ensemble practice', 'Dance and theater workshops', 'Seasonal showcases'],
          images: [clubImage2, clubImage3, clubImage1],
        },
        {
          title: 'Science, Coding, and Innovation',
          subtitle: 'Curiosity-driven exploration',
          description:
            'Hands-on experiments, coding clubs, and robotics challenges encourage students to solve real-world problems. The program culminates with STEM fairs and innovation showcases.',
          highlights: ['Weekly lab explorations', 'Robotics and coding labs', 'Innovation showcase'],
          images: [clubImage3, clubImage5, clubImage2],
        },
        {
          title: 'Leadership & Community Service',
          subtitle: 'Grow character through impact',
          description:
            'Student leaders plan campus initiatives, service programs, and charity drives. Activities are designed to build empathy, communication skills, and a spirit of collaboration.',
          highlights: ['Student council programs', 'Community outreach', 'Leadership retreats'],
          images: [clubImage4, clubImage1, clubImage3],
        },
        {
          title: 'Language and Cultural Club',
          subtitle: 'Celebrate global perspectives',
          description:
            'Language immersion sessions, cultural days, and exchange projects build confidence and appreciation for diversity. Students practice real-world communication through themed activities.',
          highlights: ['Cultural exchange days', 'Language immersion sessions', 'International celebration week'],
          images: [clubImage5, clubImage2, clubImage4],
        },
      ],
    [page?.clubs]
  );



  const [activeClubSlides, setActiveClubSlides] = useState(

    clubs.map(() => 0)

  );



  const events = useMemo(
    () =>
      page?.events || [
        {
          title: 'SPARTAN CUPS',
          subtitle: 'Annual sports, arts, and leadership competitions',
          description:
            'Spartan Cups brings together students across levels for a full week of friendly competition, teamwork, and school pride. The program includes house teams, skill clinics, and a final celebration night with awards.',
          highlights: ['House leagues and leadership roles', 'Skill clinics led by coaches', 'Championship night and awards'],
          schedule: [
            'Week 1: Team drafting and leadership workshop',
            'Week 2: Qualifiers and sports clinics',
            'Week 3: Creative showcase + finals',
          ],
          images: [eventImage1, eventImage4, eventImage3],
        },
        {
          title: 'Entrepreneurship Program',
          subtitle: 'Ideas to impact: student-led enterprise journey',
          description:
            'Students learn how to build a business idea, pitch with confidence, and manage a mini enterprise. The program blends mentorship, budgeting, and storytelling so students gain real-world financial literacy and teamwork skills.',
          highlights: ['Mentor-led ideation labs', 'Market day with student booths', 'Pitching and storytelling training'],
          schedule: [
            'Phase 1: Idea sprint + customer interviews',
            'Phase 2: Budgeting and product testing',
            'Phase 3: Market day + final pitch',
          ],
          images: [eventImage2, eventImage5, eventImage3],
        },
        {
          title: 'STEM Program',
          subtitle: 'Innovation, coding, and scientific discovery',
          description:
            'From coding challenges to science fairs, the STEM program encourages experimentation and collaboration. Students work on real problems, build prototypes, and present solutions at the annual Innovation Expo.',
          highlights: ['Robotics and coding labs', 'Science fair exhibition', 'Innovation Expo and demos'],
          schedule: [
            'Cycle 1: Design thinking and research',
            'Cycle 2: Build, test, and iterate',
            'Cycle 3: Expo prep and showcases',
          ],
          images: [eventImage3, eventImage1, eventImage2],
        },
      ],
    [page?.events]
  );



  const houseSystem = page?.house_system || {

    title: 'House System',

    subtitle: 'Belonging, leadership, and school pride',

    description:

      'Our House System groups students across grades into supportive teams that build unity, responsibility, and healthy competition. Each house earns points through academics, service, and events, encouraging students to lead with character.',

    houses: [

      { name: 'House of Courage', motto: 'Courage Unlocks Dreams', color: '#dc2626', image: clubImage1 },

      { name: 'House of Love', motto: 'Love Guides Us Forward', color: '#ec4899', image: clubImage2 },

      { name: 'House of Hope', motto: 'Hope Lights the Way', color: '#eab308', image: clubImage3 },

      { name: 'House of Faith', motto: 'Faith Guides Our Path', color: '#f97316', image: clubImage4 },

      { name: 'House of Peace', motto: 'Peace Leads Us Forward', color: '#22c55e', image: clubImage5 },

    ],

    image: clubImage4,

    imageLabel: 'House Gallery',

    imageCaption: 'Space for a featured house photo or house activity moment.',

  };



  const wellbeing = page?.wellbeing || {

    title: 'Wellbeing & Social Emotional Learning',

    subtitle: 'Support for emotional and academic growth',

    description:

      'Our SEL framework helps students build resilience, confidence, and healthy relationships while supporting academic success. Dedicated counselors, advisory teachers, and structured lessons ensure every student feels seen and supported.',

    pillars: ['Self-awareness', 'Emotional regulation', 'Empathy & kindness', 'Goal setting', 'Positive relationships'],

    supports: [

      {

        title: 'Counselor Check-ins',

        detail: 'Regular sessions for guidance, emotional support, and personal goal planning.',

        icon: 'fa-user-tie',

      },

      {

        title: 'Advisory Circles',

        detail: 'Weekly small-group conversations that build trust and communication skills.',

        icon: 'fa-users',

      },

      {

        title: 'Academic Coaching',

        detail: 'Study strategies, time management, and learning support tailored to each student.',

        icon: 'fa-book',

      },

      {

        title: 'Family Partnership',

        detail: 'Parent updates, workshops, and shared action plans for wellbeing at home.',

        icon: 'fa-home',

      },

      {

        title: 'Peer Mentoring',

        detail: 'Older students support younger peers through buddy programs, fostering leadership and belonging.',

        icon: 'fa-handshake',

      },

    ],

    image: clubImage2,

  };



  const treeZoneContent = {
    wellbeing: {
      title: 'WELLBEING',
      subtitle: 'Support for emotional and academic growth',
      content: [
        {
          heading: 'Physical Wellbeing (Kesehatan fisik)',
          points: [
            'Cognitive stamina and focus',
            'Emotional regulation & alertness',
            'Psychomotor development',
            'Vitality, resilience, stress management'
          ]
        },
        {
          heading: 'Social Wellbeing (Kesehatan sosial)',
          points: [
            'Active listening',
            'Conflict resolution',
            'Inclusivity',
            'Responsible and engaged'
          ]
        },
        {
          heading: 'Emotional wellbeing (kesehatan emosional)',
          points: [
            'Metacognitive awareness'
          ]
        }
      ]
    },
    sel: {
      title: 'SOCIAL EMOTIONAL LEARNING (SEL) as STEM',
      subtitle: 'Essential soft skills development based on eastern culture value',
      content: [
        {
          heading: 'SELF – AWARENESS',
          points: [
            'Recognizing own emotions, thought and values',
            'Understand how feelings influence behaviour',
            'Well-grounded sense of growth mindset'
          ]
        },
        {
          heading: 'SELF – MANAGEMENT',
          points: [
            'Managing stress, controlling impulses',
            'Staying motivated to reach personal / academic goals'
          ]
        },
        {
          heading: 'SOCIAL AWARENESS',
          points: [
            'Perspective of others, with diverse backgrounds',
            'Understanding social cues and norms'
          ]
        },
        {
          heading: 'RELATIONSHIP SKILLS',
          points: [
            'Establish and maintain healthy relationship',
            'Communicating clearly, listening attentively, cooperating',
            'Resisting social pressure including bullying'
          ]
        },
        {
          heading: 'RESPONSIBLE DECISION – MAKING',
          points: [
            'Making constructive choices',
            'Social interaction based on ethical standards, safety concerns and social norms'
          ]
        }
      ]
    },
    easternCulture: {
      title: 'EASTERN CULTURE VALUE as the ROOT',
      subtitle: 'Menjadi fondasi karakter dengan pilar',
      content: [
        {
          heading: 'GRACE AND COURTESY (RESPECT)',
          points: [
            'Respect the Elders',
            'Respect the Authority and Hierarchy',
            'Respect the Environment',
            'Respect the Traditional & Cultural heritage'
          ]
        },
        {
          heading: 'HARMONY AND BALANCE',
          points: [
            'Kindness, social harmony',
            'Mutual Cooperation (Gotong royong)',
            'Filial piety (Bakti kepada orangtua)'
          ]
        },
        {
          heading: 'SELF-DISCIPLINE',
          points: [
            'Self Commitment & Orderliness',
            'Self-Restraint, Self-Controlled',
            'Perseverance & Grit'
          ]
        },
        {
          heading: 'SPIRITUAL & MORAL',
          points: [
            'Faith & Spirituality',
            'Honesty',
            'Humility & Modesty',
            'Mindfulness'
          ]
        }
      ]
    }
  };

  useEffect(() => {
    setActiveClubSlides(clubs.map(() => 0));
  }, [clubs]);



  const [activeEventSlides, setActiveEventSlides] = useState(

    events.map(() => 0)

  );



  useEffect(() => {
    setActiveEventSlides(events.map(() => 0));
  }, [events]);



  useEffect(() => {

    const intervalId = setInterval(() => {

      setActiveClubSlides((current) =>

        current.map((value, index) => (value + 1) % clubs[index].images.length)

      );

    }, 4500);



    return () => clearInterval(intervalId);

  }, [clubs]);



  useEffect(() => {

    const intervalId = setInterval(() => {

      setActiveEventSlides((current) =>

        current.map((value, index) => (value + 1) % events[index].images.length)

      );

    }, 4800);



    return () => clearInterval(intervalId);

  }, [events]);



  useEffect(() => {

    const animatedItems = document.querySelectorAll('.life-animate, .event-animate');

    if (!animatedItems.length) {

      return undefined;

    }



    const observer = new IntersectionObserver(

      (entries) => {

        entries.forEach((entry) => {

          if (entry.isIntersecting) {

            entry.target.classList.add('is-visible');

            observer.unobserve(entry.target);

          }

        });

      },

      { threshold: 0.2 }

    );



    animatedItems.forEach((item) => observer.observe(item));



    return () => observer.disconnect();

  }, []);



  const heroTitle = page?.title || 'Student Life';

  const heroSummary =

    page?.summary ||

    'A vibrant campus rhythm filled with clubs, leadership, arts, sports, and community experiences.';



  return (

    <section className="student-life-page">

      <section className="student-life-hero" id="student-life-overview">

        <div className="student-life-hero-media" aria-hidden="true">

          {heroSlides.map((slide, index) => (

            <div

              key={slide}

              className={`student-life-hero-slide ${index === activeHero ? 'active' : ''}`}

            >

              <img src={slide} alt="Student life hero" />

            </div>

          ))}

        </div>

        <div className="student-life-hero-overlay" aria-hidden="true" />

        <div className="student-life-hero-content">

          <p className="student-life-hero-kicker">Student Life</p>

          <h2>{heroTitle}</h2>

          <p>{heroSummary}</p>

          <div className="student-life-hero-dots" role="tablist" aria-label="Student life hero slides">

            {heroSlides.map((slide, index) => (

              <button

                key={slide}

                type="button"

                className={`student-life-hero-dot ${index === activeHero ? 'active' : ''}`}

                onClick={() => setActiveHero(index)}

                aria-label={`Show slide ${index + 1}`}

              />

            ))}

          </div>

        </div>

      </section>



      <section className="student-life-clubs" id="clubs-eca">

        <div className="student-life-clubs-header">

          <p className="student-life-clubs-kicker">Clubs & ECA</p>

          <h3>Explore activities that build confidence, creativity, and friendship</h3>

          <p>

            Our clubs and extracurricular activities are designed to help students discover passions, practice leadership,

            and build lasting skills beyond the classroom. Each club features recurring sessions, guided mentorship, and

            student-led showcases.

          </p>

        </div>



        <div className="student-life-clubs-grid">

          {clubs.map((club, index) => (

            <article className="student-life-club-card life-animate" key={club.title}>

              <div className="student-life-club-content">

                <p className="student-life-club-label">{club.subtitle}</p>

                <h4>{club.title}</h4>

                <p>{club.description}</p>

                <ul>

                  {club.highlights.map((item) => (

                    <li key={item}>{item}</li>

                  ))}

                </ul>

              </div>



              <div className="student-life-club-media" aria-hidden="true">

                {club.images.map((image, imageIndex) => (

                  <div

                    key={`${club.title}-${image}`}

                    className={`student-life-club-slide ${

                      imageIndex === activeClubSlides[index] ? 'active' : ''

                    }`}

                  >

                    <img src={image} alt={`${club.title} activity`} />

                  </div>

                ))}

                <div className="student-life-club-dots">

                  {club.images.map((image, imageIndex) => (

                    <button

                      key={`${club.title}-${image}-dot`}

                      type="button"

                      className={`student-life-club-dot ${

                        imageIndex === activeClubSlides[index] ? 'active' : ''

                      }`}

                      onClick={() =>

                        setActiveClubSlides((current) =>

                          current.map((value, idx) =>

                            idx === index ? imageIndex : value

                          )

                        )

                      }

                      aria-label={`Show ${club.title} slide ${imageIndex + 1}`}

                    />

                  ))}

                </div>

              </div>

            </article>

          ))}

        </div>

      </section>



      <section className="events-list" id="events-competitions">

        <div className="events-list-header">

          <p className="events-list-kicker">Events & Competitions</p>

          <h3>SPARTAN Cups, Entrepreneurship, and STEM highlights</h3>

          <p>

            Signature programs that build teamwork, innovation, and leadership. Each event includes mentoring,

            showcases, and hands-on activities that keep students engaged throughout the year.

          </p>

        </div>



        <div className="events-grid">

          {events.map((event, index) => (

            <article className="events-card event-animate" key={event.title}>

              <div className="events-card-content">

                <p className="events-card-label">{event.subtitle}</p>

                <h4>{event.title}</h4>

                <p>{event.description}</p>

                <div className="events-card-section">

                  <h5>Highlights</h5>

                  <div className="events-chip-row">

                    {event.highlights.map((item) => (

                      <span key={item}>{item}</span>

                    ))}

                  </div>

                </div>

                <div className="events-card-section">

                  <h5>Program Flow</h5>

                  <ul>

                    {event.schedule.map((item) => (

                      <li key={item}>{item}</li>

                    ))}

                  </ul>

                </div>

              </div>



              <div className="events-card-media" aria-hidden="true">

                {event.images.map((image, imageIndex) => (

                  <div

                    key={`${event.title}-${image}`}

                    className={`events-card-slide ${

                      imageIndex === activeEventSlides[index] ? 'active' : ''

                    }`}

                  >

                    <img src={image} alt={`${event.title} activity`} />

                  </div>

                ))}

                <div className="events-card-dots">

                  {event.images.map((image, imageIndex) => (

                    <button

                      key={`${event.title}-${image}-dot`}

                      type="button"

                      className={`events-card-dot ${

                        imageIndex === activeEventSlides[index] ? 'active' : ''

                      }`}

                      onClick={() =>

                        setActiveEventSlides((current) =>

                          current.map((value, idx) => (idx === index ? imageIndex : value))

                        )

                      }

                      aria-label={`Show ${event.title} slide ${imageIndex + 1}`}

                    />

                  ))}

                </div>

              </div>

            </article>

          ))}

        </div>

      </section>



      <section className="house-system" id="house-system">

        <div className="house-system-header">

          <p className="house-system-kicker">House System</p>

          <h3>{houseSystem.title}</h3>

          <p>{houseSystem.description}</p>

        </div>



        <div className="house-system-grid">

          {houseSystem.houses.map((house) => (

            <article

              key={house.name}

              className="house-system-card life-animate"

              onClick={() => onNavigate && onNavigate(`house-${house.name.toLowerCase().replace(/\s+/g, '-')}`)}

              role="button"

              tabIndex={0}

              onKeyPress={(e) => {

                if (e.key === 'Enter' || e.key === ' ') {

                  onNavigate && onNavigate(`house-${house.name.toLowerCase().replace(/\s+/g, '-')}`);

                }

              }}

            >

              <div className="house-system-card-image" style={{ backgroundImage: `url(${house.image})` }} aria-hidden="true">

                <div className="house-system-card-overlay" />

              </div>

              <div className="house-system-card-content">

                <h4>{house.name}</h4>

                <p className="house-system-card-motto">"{house.motto}"</p>

                <div className="house-system-card-badge" style={{ backgroundColor: house.color }} />

              </div>

            </article>

          ))}

        </div>

      </section>



      <section className="wellbeing-section" id="wellbeing-sel">

        <div className="wellbeing-container">

          <div className="wellbeing-header">

            <p className="wellbeing-kicker">Wellbeing & Social Emotional Learning</p>

            <h3>Support for emotional and academic growth</h3>

            <p>Our SEL framework helps students build resilience, confidence, and healthy relationships while supporting academic success. Dedicated counselors, advisory teachers, and structured lessons ensure every student feels seen and supported.</p>

          </div>



          <div className="wellbeing-content">

            <div className="wellbeing-image-section life-animate">

              <div className="wellbeing-image-wrapper">

                {[wellbeing.image, clubImage3, clubImage4].map((image, index) => (

                  <div

                    key={`wellbeing-img-${index}`}

                    className={`wellbeing-image-slide ${index === activeWellbeingSlide ? 'active' : ''}`}

                  >

                    <img src={image} alt="Wellbeing moment" />

                  </div>

                ))}

                <div className="wellbeing-image-dots">

                  {[0, 1, 2].map((index) => (

                    <button

                      key={`wellbeing-img-dot-${index}`}

                      type="button"

                      className={`wellbeing-image-dot ${index === activeWellbeingSlide ? 'active' : ''}`}

                      onClick={() => setActiveWellbeingSlide(index)}

                      aria-label={`Show slide ${index + 1}`}

                    />

                  ))}

                </div>

              </div>

            </div>



            <div className="wellbeing-info-section">

              <div className="wellbeing-pillars-section life-animate">

                <h4>Core Pillars</h4>

                <div className="wellbeing-pillars-grid">

                  {wellbeing.pillars.map((pillar, index) => (

                    <div key={pillar} className="wellbeing-pillar-item">

                      <div className="wellbeing-pillar-icon">

                        <i className="fas fa-star" />

                      </div>

                      <p>{pillar}</p>

                    </div>

                  ))}

                </div>

              </div>



              <div className="wellbeing-supports-section life-animate">

                <h4>Support Pathways</h4>

                <div className="wellbeing-supports-grid">

                  {wellbeing.supports.map((support, index) => (

                    <div

                      key={support.title}

                      className={`wellbeing-support-card ${index === activeWellbeingCard ? 'active' : ''}`}

                      onClick={() => setActiveWellbeingCard(index)}

                      role="button"

                      tabIndex={0}

                      onKeyPress={(e) => {

                        if (e.key === 'Enter' || e.key === ' ') {

                          setActiveWellbeingCard(index);

                        }

                      }}

                    >

                      <div className="wellbeing-support-icon">

                        <i className={`fas ${support.icon}`} />

                      </div>

                      <h5>{support.title}</h5>

                      <p>{support.detail}</p>

                    </div>

                  ))}

                </div>

              </div>

            </div>

          </div>

        </div>

      </section>



      <section className="character-shaping-section" id="character-shaping">

        <div className="character-shaping-container">

          <div className="character-shaping-header life-animate">

            <p className="character-shaping-kicker">Our Framework</p>

            <h3>Character Shaping Program</h3>

            <p>A holistic approach to student development built on three interconnected pillars: Eastern Culture values as our foundation, Social Emotional Learning as our growth structure, and Wellbeing as our flourishing leaves.</p>

          </div>

          <div className="tree-interactive-wrapper life-animate">

            {/* Main Tree Image with Interactive Zones */}

            <div className="tree-image-container">

              <img 

                src={treeImage} 

                alt="Character Shaping Program: Eastern Culture Foundation, SEL Growth, Wellbeing Flourishing" 

                className="tree-image-main" 

                role="presentation"

              />

              {/* Eastern Culture - Bottom Center */}

              <button

                type="button"

                className="tree-interactive-label tree-label-roots"

                onClick={() => {

                  setActiveTreeZone('easternCulture');

                  setShowTreeModal(true);

                }}

                aria-label="Explore Eastern Culture"

              >

                EASTERN CULTURE

              </button>

              {/* SEL - Center Trunk */}

              <button

                type="button"

                className="tree-interactive-label tree-label-trunk"

                onClick={() => {

                  setActiveTreeZone('sel');

                  setShowTreeModal(true);

                }}

                aria-label="Explore Social Emotional Learning"

              >

                SOCIAL EMOTIONAL<br/>LEARNING

              </button>

              {/* Wellbeing - Right Top */}

              <button

                type="button"

                className="tree-interactive-label tree-label-leaves"

                onClick={() => {

                  setActiveTreeZone('wellbeing');

                  setShowTreeModal(true);

                }}

                aria-label="Explore Wellbeing"

              >

                WELLBEING

              </button>

            </div>

            {/* Remove old tree-buttons-overlay */}



            {/* Tree Zone Info Panels - Mobile/Below */}

            <div className="tree-zones-info-grid">

              <div

                className="tree-zone-info-card tree-zone-info-roots life-animate"

              >

                <div className="info-card-icon">

                  <i className="fas fa-om" />

                </div>

                <h4>Eastern Culture</h4>

                <p>The ROOT: Respect, harmony, and shared responsibility</p>

              </div>



              <div

                className="tree-zone-info-card tree-zone-info-trunk life-animate"

              >

                <div className="info-card-icon">

                  <i className="fas fa-brain" />

                </div>

                <h4>Social Emotional Learning</h4>

                <p>The TRUNK: Essential soft skills and emotional resilience</p>

              </div>



              <div

                className="tree-zone-info-card tree-zone-info-leaves life-animate"

              >

                <div className="info-card-icon">

                  <i className="fas fa-heart" />

                </div>

                <h4>Wellbeing</h4>

                <p>The LEAVES: Flourishing emotional and academic growth</p>

              </div>

            </div>

          </div>

        </div>

      </section>



      {showTreeModal && (

        <div className="tree-modal-overlay" onClick={() => setShowTreeModal(false)} role="presentation" aria-hidden="true">

          <div 

            className="tree-modal"

            onClick={(e) => e.stopPropagation()} 

            data-zone={activeTreeZone === 'easternCulture' ? 'eastern-culture' : activeTreeZone}

            role="dialog"

            aria-modal="true"

            aria-labelledby="tree-modal-title"

          >

            <button

              type="button"

              className="tree-modal-close"

              onClick={() => setShowTreeModal(false)}

              aria-label="Close Character Shaping modal"

            >

              <i className="fas fa-times" />

            </button>



            <div className="tree-modal-header">

              <div className="tree-modal-icon">

                {activeTreeZone === 'wellbeing' && <i className="fas fa-heart" />}

                {activeTreeZone === 'sel' && <i className="fas fa-brain" />}

                {activeTreeZone === 'easternCulture' && <i className="fas fa-leaf" />}

              </div>

              <h3 id="tree-modal-title">{treeZoneContent[activeTreeZone].title}</h3>

              <p className="tree-modal-subtitle">{treeZoneContent[activeTreeZone].subtitle}</p>

            </div>



            <div className="tree-modal-body">

              <div className="tree-zone-content-list">

                {treeZoneContent[activeTreeZone].content.map((section, idx) => (

                  <div key={idx} className="content-section">

                    <h4>{section.heading}</h4>

                    <ul>

                      {section.points.map((point, pIdx) => (

                        <li key={pIdx}>

                          <span className="list-bullet">•</span>

                          {point}

                        </li>

                      ))}

                    </ul>

                  </div>

                ))}

              </div>

            </div>



            <div className="tree-modal-footer">

              <p className="tree-modal-hint">Explore other zones to see more about our Character Shaping Program</p>

            </div>

          </div>

        </div>

      )}



      <section className="leaps-section" id="leaps">

        <div className="leaps-container">

          <div className="leaps-header">

            <p className="leaps-kicker">Student Development</p>

            <h3>LEAPS Framework</h3>

            <p>Our holistic approach to student growth encompasses five key dimensions that shape well-rounded learners and responsible global citizens.</p>

          </div>



          <div className="leaps-grid life-animate">

            {[

              {

                letter: 'L',

                fullText: 'Leadership',

                description: 'Developing confident decision-makers who inspire and guide others with integrity and vision.',

                icon: 'fa-crown',

                color: '#FF6B6B',

              },

              {

                letter: 'E',

                fullText: 'Extracurricular',

                description: 'Exploring passions through clubs, sports, arts, and activities that build skills beyond the classroom.',

                icon: 'fa-star',

                color: '#FFD93D',

              },

              {

                letter: 'A',

                fullText: 'Achievement',

                description: 'Pursuing academic excellence and personal growth through dedication, effort, and continuous improvement.',

                icon: 'fa-trophy',

                color: '#6BCB77',

              },

              {

                letter: 'P',

                fullText: 'Participation',

                description: 'Actively engaging in school life, community events, and collaborative projects that strengthen bonds.',

                icon: 'fa-handshake',

                color: '#4D96FF',

              },

              {

                letter: 'S',

                fullText: 'Service',

                description: 'Contributing to society through meaningful service, empathy, and commitment to making a positive impact.',

                icon: 'fa-heart',

                color: '#1E3A8A',

              },

            ].map((item, index) => (

              <div

                key={item.letter}

                className={`leaps-card life-animate ${flippedLeapsCard === item.letter ? 'flipped' : ''}`}

                style={{ '--card-color': item.color }}

                onClick={() => setFlippedLeapsCard(flippedLeapsCard === item.letter ? null : item.letter)}

                role="button"

                tabIndex={0}

                onKeyPress={(e) => {

                  if (e.key === 'Enter' || e.key === ' ') {

                    setFlippedLeapsCard(flippedLeapsCard === item.letter ? null : item.letter);

                  }

                }}

              >

                <div className="leaps-card-front">

                  <div className="leaps-letter" style={{ backgroundColor: item.color }}>

                    {item.letter}

                  </div>

                </div>

                <div className="leaps-card-back">

                  <div className="leaps-back-content">

                    <h4>{item.fullText}</h4>

                    <p>{item.description}</p>

                    <div className="leaps-icon">

                      <i className={`fas ${item.icon}`} />

                    </div>

                  </div>

                </div>

              </div>

            ))}

          </div>

        </div>

      </section>

    </section>

  );

}



export default StudentLifePage;

